import PropTypes from 'prop-types';
import React from 'react';

import { threatLevelName } from '~app/actions/wildlife';

import defined from '~app/core/defined';

import Divider from './Divider';

const WildlifeDetailsHeader = ({selectedSpeciesContent}) => {
  if (defined(selectedSpeciesContent)) {
    const commonName = selectedSpeciesContent.name;
    const binomial = selectedSpeciesContent.binomial;
    const threatLevel = threatLevelName(selectedSpeciesContent.threat_level);

    return (
      <div className="WildlifeDetailsHeader">

        <div className="WildlifeDetailsHeader__nameSection">
          <span className="WildlifeDetailsHeader__commonName">
            {commonName}
          </span>
          <span className="WildlifeDetailsHeader__binomial">
            {binomial}
          </span>
        </div>

        <Divider />

        <div className="WildlifeDetailsHeader__threatSection">
          <span className="WildlifeDetailsHeader__threatName">
            {threatLevel}
          </span>
        </div>

      </div>
    );
  }

  return null;
};

WildlifeDetailsHeader.propTypes = {
  selectedSpeciesContent: PropTypes.object,
};

export default WildlifeDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/WildlifeDetailsHeader.js